import clsx from "clsx";
import * as styles  from "./styles.module.scss";

export const Image = ({ src, alt, srcSet, sizes }) => {
    if (!src) {
        return null;    
    }

    return (
        <figure className={styles.figure}>
            <img className={styles.image} src={src} alt={alt || ''} srcSet={srcSet || null} sizes={sizes || null} loading="lazy" />
        </figure>
    );
};
